import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgenticPlanningRelayProvider = {
	get(): boolean {
		return fg('jira-ai-agentic-planning-technical-changes');
	},
};

export default JiraAiAgenticPlanningRelayProvider;
